// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import CheckSvg from '@rsuite/icon-font/lib/application/Check';
var Check = createSvgIcon({
    as: CheckSvg,
    ariaLabel: 'check',
    category: 'application',
    displayName: 'Check'
});
export default Check;
